export class PanelVisibilityHelper {
  public static isCovered(point: { x: number; y: number }, panel: { left: number; right: number; top: number; bottom: number }, margin = 28): boolean {
    return point.x >= panel.left - margin && point.x <= panel.right + margin && point.y >= panel.top - margin && point.y <= panel.bottom + margin;
  }
}
